module.exports = __webpack_public_path__ + "img/rain.d7fbbce5.svg";